/* GLOBAL COMPUTE STYLES */
import { css } from '@linaria/core';
import { baseTheme } from 'styles/utils';
export const computePageStyles = {
  layout: "odules__Compute__styles_ts-layout-laob8g0",
  wrapper: "odules__Compute__styles_ts-wrapper-wxyktb5",
  createInstanceTable: "odules__Compute__styles_ts-createInstanceTable-c1o589d5",
  createForm: "odules__Compute__styles_ts-createForm-c10l4e5c",
  deployForm: "odules__Compute__styles_ts-deployForm-dbxk9zk"
};
export const computeDashboardStyles = {
  cardsContainer: "odules__Compute__styles_ts-cardsContainer-c53pibm"
};
export const computeViewStyles = {
  content: "odules__Compute__styles_ts-content-c14twfgv",
  sectionHeader: "odules__Compute__styles_ts-sectionHeader-spek65h"
};
export const computeFormStyles = {
  limitInputWidth: "odules__Compute__styles_ts-limitInputWidth-l1anx59p",
  leftPaddedField: "odules__Compute__styles_ts-leftPaddedField-lrmo79f",
  input: "odules__Compute__styles_ts-input-ig90aev",
  checkbox: "odules__Compute__styles_ts-checkbox-c14r7wbi",
  switch: "odules__Compute__styles_ts-switch-srlu9dz",
  checkboxLabel: "odules__Compute__styles_ts-checkboxLabel-cqs0xtl",
  uniqueId: "odules__Compute__styles_ts-uniqueId-u1cw6wlf",
  hint: "odules__Compute__styles_ts-hint-h1ah0a1e",
  sectionDivider: "odules__Compute__styles_ts-sectionDivider-s1nbwged",
  compatibilityStatus: "odules__Compute__styles_ts-compatibilityStatus-c1j66b7c",
  internalOnly: "odules__Compute__styles_ts-internalOnly-iakw9t0",
  internalOnlyText: "odules__Compute__styles_ts-internalOnlyText-ie2z5j9",
  internalOnlyDescription: "odules__Compute__styles_ts-internalOnlyDescription-ian1w9q",
  formContent: "odules__Compute__styles_ts-formContent-f1ma17cs",
  formContentLoading: "odules__Compute__styles_ts-formContentLoading-f1x1d770"
};
export const computeActionStyles = {
  actionListButton: "odules__Compute__styles_ts-actionListButton-a1pb91gq",
  deleteModalLayout: "odules__Compute__styles_ts-deleteModalLayout-dp5qtdp",
  deleteModalIds: "odules__Compute__styles_ts-deleteModalIds-d153flhr",
  deleteModalConfirm: "odules__Compute__styles_ts-deleteModalConfirm-d9fkf27"
};
export const computeTableStyles = {
  table: "odules__Compute__styles_ts-table-t1lojums",
  tableControlsWrapper: "odules__Compute__styles_ts-tableControlsWrapper-t17mec35",
  tableControlsLeft: "odules__Compute__styles_ts-tableControlsLeft-t1mg5ic8",
  tableControlsRight: "odules__Compute__styles_ts-tableControlsRight-t1un4gfn",
  tableFilters: "odules__Compute__styles_ts-tableFilters-t1o2pjta",
  searchInput: "odules__Compute__styles_ts-searchInput-satao9m"
};
export const computeProviderStyles = {
  optionLayout: "odules__Compute__styles_ts-optionLayout-oc2ob0s",
  optionIcon: "odules__Compute__styles_ts-optionIcon-oh6obpu",
  optionText: "odules__Compute__styles_ts-optionText-osyt3o9"
};
export const computeInfoCardStyles = {
  wrapper: "odules__Compute__styles_ts-wrapper-w1phq4fe",
  title: "odules__Compute__styles_ts-title-t4k1sg9",
  fullWidth: "odules__Compute__styles_ts-fullWidth-f1s9r9ti",
  tightLayout: "odules__Compute__styles_ts-tightLayout-t6inm2s",
  spreadLayout: "odules__Compute__styles_ts-spreadLayout-s18bnjbi",
  detailsSection: "odules__Compute__styles_ts-detailsSection-d6aje4o",
  overviewLink: "odules__Compute__styles_ts-overviewLink-o184ttuk",
  capacityType: "odules__Compute__styles_ts-capacityType-c1ysoh5q",
  clusterDetailsText: "odules__Compute__styles_ts-clusterDetailsText-c1h62hgs",
  divider: "odules__Compute__styles_ts-divider-dp7h81m"
};

// Shared styles for hardware templates
export const computeHardwareTemplateStyles = {
  layout: "odules__Compute__styles_ts-layout-l1ibh43u",
  instanceItem: "odules__Compute__styles_ts-instanceItem-iadi5cf",
  templateContent: "odules__Compute__styles_ts-templateContent-t1m2qmnq",
  memory: "odules__Compute__styles_ts-memory-m1l307x1",
  configDetails: "odules__Compute__styles_ts-configDetails-c10lsk87",
  configDetailsTitle: "odules__Compute__styles_ts-configDetailsTitle-cjb70tx",
  configDetailsLink: "odules__Compute__styles_ts-configDetailsLink-cg56fhd"
};

require("./styles.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./styles.ts");